import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Chart as ChartJS, registerables } from 'chart.js';
import { useAppContext } from '@/common/context-providers/AppProvider';
import { MsalProvider } from '@azure/msal-react';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import { browsers } from '@/common/utils/browserDetection';
import { router } from './routes';
import { ToastContainer } from 'react-toastify';

ChartJS.register(...registerables);

const App = () => {
  const {
    config: { navbarPosition },
    msalInstance
  } = useAppContext();
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;

  useEffect(() => {
    if (browsers.isWindows()) {
      HTMLClassList.add('windows');
    }
    if (browsers.isChrome()) {
      HTMLClassList.add('chrome');
    }
    if (browsers.isFirefox()) {
      HTMLClassList.add('firefox');
    }
    if (browsers.isSafari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  return (
    <MsalProvider instance={msalInstance}>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick
        newestOnTop
        theme="colored"
      />
      <RouterProvider router={router} />
    </MsalProvider>
  );
};

export default App;
